var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 5.00857C10.3333 4.66735 10.2031 4.32614 9.94281 4.0658C9.68246 3.80545 9.34123 3.67527 9 3.67527M9 9.00861C11.2091 9.00861 13 7.21775 13 5.00861C13 2.79947 11.2091 1.00861 9 1.00861C6.79086 1.00861 5 2.79947 5 5.00861C5 5.19106 5.01222 5.37066 5.03587 5.54663C5.07478 5.83606 5.09424 5.98077 5.08114 6.07233C5.0675 6.16771 5.05013 6.2191 5.00313 6.30321C4.958 6.38394 4.87847 6.46347 4.71942 6.62252L1.31242 10.0295C1.19712 10.1448 1.13947 10.2025 1.09824 10.2697C1.06169 10.3294 1.03475 10.3944 1.01842 10.4625C1 10.5392 1 10.6207 1 10.7838V11.9419C1 12.3153 1 12.502 1.07266 12.6446C1.13658 12.77 1.23856 12.872 1.36401 12.9359C1.50661 13.0086 1.6933 13.0086 2.06667 13.0086H3.66667V11.6753H5V10.3419H6.33333L7.38609 9.28918C7.54514 9.13013 7.62467 9.05061 7.7054 9.00548C7.7895 8.95847 7.8409 8.9411 7.93627 8.92746C8.02783 8.91437 8.17255 8.93382 8.46198 8.97273C8.63795 8.99639 8.81755 9.00861 9 9.00861Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.b4a7f24d0616a90b6945be616c28c32e.svg";
export { ForwardRef as ReactComponent };